// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-dropdown{margin-top:1px!important;max-height:50vh;overflow-y:scroll}.category-dropdown::-webkit-scrollbar{background-color:transparent;height:10px;width:10px}.category-dropdown::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.1);border:2px solid #fff;border-radius:6px}.category-dropdown::-webkit-scrollbar-thumb:hover{background-color:rgba(0,0,0,.25)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
